import React from 'react';
import { whyUsReasons } from '../data/mock';
import { 
  UserCheck, 
  Award, 
  Code2, 
  Target, 
  BarChart3, 
  Settings2,
  Zap
} from 'lucide-react';

const iconMap = {
  'Experienced Core + Accelerated Enablement': Zap,
  'OEM Battle-Tested': Award,
  'Execution Over Slides': Code2,
  'Domain Depth': Target,
  'Transparent Governance': BarChart3,
  'Flexible Engagement': Settings2
};

const WhyUs = () => {
  return (
    <section className="section-padding" id="why-us">
      <div className="container">
        <div className="section-header">
          <p className="section-label">Why Choose Us</p>
          <h2 className="section-title">The VC4U Difference</h2>
          <p className="section-description">
            We're not your typical IT consultancy. Here's why leading OEMs and technology companies partner with us.
          </p>
        </div>
        
        <div className="why-us-grid">
          {whyUsReasons.map((reason) => {
            const IconComponent = iconMap[reason.title] || UserCheck;
            return (
              <div key={reason.title} className="why-us-card">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[var(--accent-subtle)] rounded-lg flex items-center justify-center text-[var(--accent-primary)]">
                    <IconComponent size={20} />
                  </div>
                </div>
                <h3 className="why-us-title">{reason.title}</h3>
                <p className="why-us-description">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
